import { gql } from "@apollo/client";

export const DESTROY_CLIENT_SETTING = gql`
  mutation DestroyMMMClientSetting($id: ID!) {
    destroyMMMClientSetting(id: $id) {
      id
    }
  }
`;
